<style lang="scss">
  .bg-box-all {
    &.RejectionInfo-item {
      padding: 0;
      margin: 0;

      div > .bg-box-title {
        float: right;
      }

      .oms-row {
        margin-bottom: 5px;
      }
    }
  }

  .comment-part {
    .comment-item {
      border: 1px solid #eee;
      border-radius: 5px;
      margin-bottom: 5px;
      padding-left: 5px;
    }

    .header {
      overflow: hidden;
    }

    .date {
      color: #999;
    }

    .content {
      padding-left: 15px;
    }

    .attachment {
      color: #999;
    }
  }
</style>
<template>
  <div>
    <div v-if="loadingData">
      <oms-loading :loading="loadingData"></oms-loading>
    </div>
    <div v-else-if="exceptionDtoList.length===0" class="empty-info">
      暂无异常信息
    </div>
    <div v-else>
      <div v-for="exception in exceptionDtoList" :key="exception.id">
        <bg-box class="bg-box-all" :title="exception.exceptionName" type="white">
          <div class="clearfix">
            <el-row>
              <el-col :span="12" class="mb-15">
                <oms-row :span="8" label="质量检查项标准">
                  <nl2br :content="exception.criterion"></nl2br>
                </oms-row>
              </el-col>
              <el-col :span="12" class="mb-15">
                <oms-row :span="8" label="发生时间" v-show="exception.exceptionTime">{{exception.exceptionTime | time}}</oms-row>
                <oms-row :span="8" label="确认人" v-show="exception.confirmMan">{{exception.confirmMan}}</oms-row>
                <oms-row :span="8" label="确认时间" v-show="exception.confirmTime">{{exception.confirmTime | time}}
                </oms-row>
              </el-col>
            </el-row>
            <oms-row :span="4" label="异常原因附件" v-if="exception.reasonAttachments && exception.reasonAttachments.length"
                     class="mb-15 lh26">
              <attachment-show :orderAttachment="exception.reasonAttachments"
                               :attachmentRight="attachmentRights"
                               attachmentClass="exception-attachment"
                               @refreshAttachment="queryAllExceptionList"></attachment-show>
            </oms-row>
            <oms-row :span="4" class="mb-15" label="回复" v-if="exception.commentList && exception.commentList.length">
              <div class="comment-part">
                <div class="comment-item" v-for="item in exception.commentList">
                  <div class="header">
                    <span> {{ item.createdBy }}</span>
                    <span class="date  pull-right mr-10"> {{ item.createTime | time}}</span>
                  </div>
                  <el-row class="content">
                    {{item.content}}
                  </el-row>
                  <el-row v-if="item.attachmentResponseList && item.attachmentResponseList.length">
                    <span class="attachment">附件信息</span>
                    <attachment-show :orderAttachment="item.attachmentResponseList"
                                     :attachmentRight="attachmentRights"
                                     attachmentClass="exception-attachment"
                                     @refreshAttachment="queryAllExceptionList"></attachment-show>
                  </el-row>
                </div>
              </div>
            </oms-row>
            <oms-row :span="4" label="取消意见" class="mb-15"
                     v-if="exception.cancelResultList && exception.cancelResultList.length">
              <div class="comment-part">
                <div class="comment-item" v-for="item in exception.cancelResultList">
                  <div class="header">
                    <span> {{ item.creatorName }}</span>
                    <span class="date"> {{ item.createDate | time}}</span>
                  </div>
                  <el-row class="content">
                    {{item.content}}
                  </el-row>
                </div>
              </div>
            </oms-row>
          </div>
        </bg-box>
      </div>
    </div>
  </div>
</template>
<script>
  import {http} from '@/resources';
  import attachmentShow from './attachmentShow.vue';
  import bgBox from '@/components/common/bgbox.vue';

  export default {
    components: {
      attachmentShow,
      bgBox
    },
    props: {
      currentOrder: {
        required: true,
        type: Object,
        default: function () {
          return {};
        }
      },
      index: {
        type: Number,
        default: -1
      }
    },
    data() {
      return {
        loadingData: true,
        exceptionDtoList: [],
        attachmentRights: {
          download: 'show',
          remove: 'show'
        }
      };
    },
    watch: {
      index(val) {
        this.exceptionDtoList = [];
        if (val !== 5) return;
        this.queryAllExceptionList();
      }
    },
    methods: {
      queryAllExceptionList: function () {// 所有异常信息列表
        if (!this.currentOrder.id) return;
        this.loadingData = true;
        http.get('/bsp-exception/order/' + this.currentOrder.id).then(res => {
          this.loadingData = false;
          this.exceptionDtoList = res.data;
        });
      }
    }
  };
</script>
